module.exports = __webpack_public_path__ + "img/phon5-scroue.0ac8617f.png";